import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../assets/img/fcb_small.mp4";
import projImg2 from "../assets/img/sw_small.mp4";
import projImg3 from "../assets/img/fida_small.mp4";
import projImg4 from "../assets/img/psu_426x240.webp";
import projImg5 from "../assets/img/hra.webp";
import projImg6 from "../assets/img/sandbox.webp";
import projImg7 from "../assets/img/chopshop.webp";
import projImg8 from "../assets/img/POS.webp";
import projImg9 from "../assets/img/couch-counseling.webp";
import projImg10 from "../assets/img/hra-site.webp";
import projImg11 from "../assets/img/parthificial.webp";
import projImg12 from "../assets/img/fundamentpy.webp";
import projImg13 from "../assets/img/fundamentrkt.webp";
import projImg14 from "../assets/img/gpubot.webp";
import projImg15 from "../assets/img/mapper.webp";
import projImg16 from "../assets/img/hk-site.png";
import projImg17 from "../assets/img/esc.png";
import projImg18 from "../assets/img/4tk.png";
import projImg19 from "../assets/img/anithera.png";

import get_top from '../assets/modals/get_top.png';
import get_last from '../assets/modals/get_last.png';
import graph from '../assets/modals/graph.png';
import fcb_rank_card from '../assets/modals/fcb_rank_card.png';
import wr from '../assets/modals/wr.png';
import sw_bl from '../assets/modals/sw_bl.png';
import get_all from '../assets/modals/get_all.png';
import rank_card from '../assets/modals/rank_card.png';
import inrole from '../assets/modals/inrole.png';

const fcb = [get_top, get_last, fcb_rank_card, wr];
const sw = [sw_bl];
const fc = [get_all, graph, rank_card, inrole];

export const Projects = () => {

  const projects = [
    {
      title: "ForzaCompBot",
      description: "A Discord bot that surfaces Forza Horizon 3, 4, and 5 World Records via simple commands. Without official APIs, the community compiled records into a Google Sheet — I built an API wrapper around it to deliver user-friendly data. Also includes ELO ranking features from the FIDA Core bot for competitive community management.",
      imgUrl: projImg1,
      images: fcb
    },
    {
      title: "StreetBot",
      description: "Manages the Street Wars Discord server and automates the Blacklist PvP battle system for the Forza Horizon Street Wars community. Handles race tracking, rankings, and fairness enforcement, freeing up community managers to focus on engagement rather than administration.",
      imgUrl: projImg2,
      images: sw
    },
    {
      title: "FIDA Core",
      description: "An ELO ranking system Discord bot serving over 20,000 users. Members can track their progress, view leaderboards, check nearby ranks, and see top players — creating a competitive and engaging environment for the FIDA community.",
      imgUrl: projImg3,
      images: fc
    },
    {
      title: "PSU Verification",
      description: "A Discord bot that validates incoming users to the PSU Abington Computer Science server by cross-referencing the university directory with PSU email addresses. Extended with the Canvas LMS API to deliver assignment and announcement notifications directly in Discord.",
      imgUrl: projImg4,
    },
    {
      title: "HRA Submission Bot",
      description: "A Discord bot for the Forza Horizon Racing Academy that uses Optical Character Recognition (OCR) to parse race time submissions from screenshots and automatically assign member roles based on their results.",
      imgUrl: projImg5,
    },
    {
      title: "Sandbox Bot",
      description: "A personal all-in-one Discord bot featuring daily weather reports, Canvas LMS announcements, assignment notifications, file conversion utilities, server health monitoring, and a general development sandbox.",
      imgUrl: projImg6,
    },
  ];

  const app_projects = [
    {
      title: "Pizza Shop POS",
      description: "A full-stack Java desktop application — a fully featured point-of-sale system built for cashier workflows, including order management, item lookup, and transaction handling.",
      imgUrl: projImg8,
    },
    {
      title: "Fundament Python",
      description: "A language layer on top of Python that lets new programmers write plain English to execute functions, lowering the barrier to entry for beginners learning to code.",
      imgUrl: projImg12,
    },
    {
      title: "Fundament Racket",
      description: "A language layer on top of Racket/Scheme that processes natural English text and maps it to functional programming constructs, designed for introductory CS students.",
      imgUrl: projImg13,
    },
    {
      title: "Message Mapper",
      description: "Efficiently compresses text messages by building a hashmap of words and their occurrences, enabling compact storage and faithful reconstruction of the original message.",
      imgUrl: projImg15,
    },
    {
      title: "Parthificial Intelligence",
      description: "A team-built Python NLP chatbot trained to answer frequently asked questions for PSU CMPSC and IST students, reducing load on academic advisors.",
      imgUrl: projImg11,
    },
    {
      title: "GPU Hunter",
      description: "Monitored graphics card prices across multiple retailer websites and sent email or SMS alerts when a target price threshold was met — built during the GPU shortage era.",
      imgUrl: projImg14,
    },
  ];

  const web_projects = [
    {
      title: <a target="_blank" href="https://couch-counseling.netlify.app/" style={{ color: 'white', textDecoration: 'none' }} rel="noreferrer">Couch Counseling</a>,
      description: "An interactive web game for psychology students to practice client conversations and develop situational judgment in a low-stakes environment.",
      imgUrl: projImg9,
    },
    {
      title: <a target="_blank" href="https://horizonracingacademy.com/" style={{ color: 'white', textDecoration: 'none' }} rel="noreferrer">Horizon Racing Academy</a>,
      description: "A WordPress site for a virtual racing academy focused on teaching racecraft. Built in collaboration with Cast Haste.",
      imgUrl: projImg10,
    },
    {
      title: 'Chop Shop',
      description: "A companion shopping app that calculates the fastest route through a store based on a user's shopping list — reducing time spent navigating large grocery stores.",
      imgUrl: projImg7,
    },
    {
      title: <a target="_blank" href="https://www.hkimmigrationgroup.com/" style={{ color: 'white', textDecoration: 'none' }} rel="noreferrer">HK Immigration LLC</a>,
      description: "A Squarespace website for an immigration law firm, built with a second developer. I focused on layout, responsiveness, and visual consistency.",
      imgUrl: projImg16,
    },
    {
      title: <a target="_blank" href="https://escuderoelectrical.net/" style={{ color: 'white', textDecoration: 'none' }} rel="noreferrer">Escudero Electrical LLC</a>,
      description: "A custom React site built solo for an electrical contracting company, emphasizing clean design, mobile responsiveness, and fast load times.",
      imgUrl: projImg17,
    },
    {
      title: <a target="_blank" href="https://4tekies.com/" style={{ color: 'white', textDecoration: 'none' }} rel="noreferrer">4Tekies LLC</a>,
      description: "A modernized React redesign of an Angular site for a technical solutions firm — improving performance, UI clarity, and mobile experience.",
      imgUrl: projImg18,
    },
    {
      title: <a target="_blank" href="https://anithera.com/" style={{ color: 'white', textDecoration: 'none' }} rel="noreferrer">Anithera</a>,
      description: "A React site built for a medical devices company, establishing their web presence with a clean, professional layout while longer-term development continues.",
      imgUrl: projImg19,
    },
  ];

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col xs={12}>
            <h2>Projects</h2>
            <p>A selection of projects spanning Discord bots, desktop applications, and web development — built with Python, Java, and React.</p>
            <Tab.Container id="projects-tabs" defaultActiveKey="first">
              <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                <Nav.Item>
                  <Nav.Link eventKey="first">Discord</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="second">Apps</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="third">Websites</Nav.Link>
                </Nav.Item>
              </Nav>
              <Tab.Content id="slideInUp">
                <Tab.Pane eventKey="first">
                  <Row>
                    {projects.map((project, index) => (
                      <ProjectCard key={index} {...project} />
                    ))}
                  </Row>
                  <p>Integrations include MongoDB, asynchronous Python, Google Sheets API, Pandas, ELO management, role systems, inter-server communication, and scheduled scripts.</p>
                </Tab.Pane>
                <Tab.Pane eventKey="second">
                  <Row>
                    {app_projects.map((project, index) => (
                      <ProjectCard key={index} {...project} />
                    ))}
                  </Row>
                  <p>These projects pushed complexity in data structures, language design, and real-time data — all areas with strong potential for future development.</p>
                </Tab.Pane>
                <Tab.Pane eventKey="third">
                  <Row>
                    {web_projects.map((project, index) => (
                      <ProjectCard key={index} {...project} />
                    ))}
                  </Row>
                  <p>Web work spans client sites, team collaborations, and personal projects — built with React, WordPress, and Squarespace across a variety of industries.</p>
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Projects;
